(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["joy-clean-system"]) return;
  try {
    
if (!customElements.get('joy-gift-finder')) {
  customElements.define('joy-gift-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('change', () => this.updateResults());
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        this.updateResults();
        this.querySelector('.joy-finder-results').scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'nearest'});
      });
      this.updateResults();
    }
    updateResults() {
      const recipient = this.querySelector('[name="joy-recipient"]:checked').value;
      const budget = Number(this.querySelector('[name="joy-budget"]:checked').value);
      let shown = 0;
      for (const item of this.querySelectorAll('.joy-finder-item')) {
        const match = Number(item.dataset.price) <= budget && item.dataset.recipients.split(' ').includes(recipient) && shown < 4;
        item.hidden = !match;
        if(match) shown++;
      }
      const status = this.querySelector('[data-joy-finder-status]');
      status.textContent = status.dataset.template.replace('[count]', String(shown));
      this.querySelector('[data-joy-finder-empty]').hidden = shown > 0;
      const link = this.querySelector('[data-joy-finder-all]');
      const url = new URL(link.href);
      url.searchParams.set('filter.v.price.lte', String(budget / 100));
      link.href = url.href;
    }
  });
}
if (!window.joyPreviewEventsBound) {
  window.joyPreviewEventsBound = true;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-joy-media-open]');
    if(opener) {
      const dialog = document.getElementById(opener.dataset.joyMediaOpen);
      if(dialog && !dialog.open) { dialog.showModal(); dialog.dataset.returnFocus = opener.dataset.joyMediaOpen; }
    }
    const closer = event.target.closest('[data-joy-media-close]');
    if(closer) closer.closest('dialog').close();
    if(event.target.matches('dialog.joy-media-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if(!event.target.matches('dialog.joy-media-dialog')) return;
    event.target.querySelectorAll('video').forEach(video => video.pause());
    document.querySelector('[data-joy-media-open="' + event.target.id + '"]')?.focus();
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.joy-addon-form');
    if(!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if(button.disabled) return;
    const status = form.closest('.joy-pairing').querySelector('.joy-addon-status');
    status.textContent = '';
    button.disabled = true;
    const data = new FormData(form);
    data.set('sections', 'cart-drawer,cart-bubble,main-cart');
    data.set('sections_url', window.location.pathname);
    let added = false;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:data});
      const result = await response.json();
      if(!response.ok || result.status) throw new Error(result.description || status.dataset.error);
      added = true;
      const sections = [
        ['Cart-Drawer','cart-drawer','.cart-drawer'],
        ['cart-drawer-toggle','cart-bubble','.thb-item-count'],
        ['Cart','main-cart','.thb-cart-form']
      ];
      for(const [id,key,selector] of sections) {
        const current = document.getElementById(id);
        if(!current || !result.sections?.[key]) continue;
        const incoming = new DOMParser().parseFromString(result.sections[key], 'text/html').querySelector(selector);
        if(incoming) (current.querySelector(selector) || current).innerHTML = incoming.innerHTML;
      }
      document.dispatchEvent(new CustomEvent('cart:item-added',{detail:{product:result.items?.[0] || result}}));
      const drawer = document.getElementById('Cart-Drawer');
      if(drawer) document.getElementById('cart-drawer-toggle')?.click();
      else window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      status.textContent = status.dataset.added;
    } catch(error) {
      status.textContent = added ? status.dataset.added : (error.message || status.dataset.error);
      if(added) document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      button.disabled = false;
    }
  });
}


if (!window.joyNatureMotionBound) {
  window.joyNatureMotionBound = true;
  const revealNatureSections = root => {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => {
      for(const entry of entries) if(entry.isIntersecting) { entry.target.classList.add('joy-in-view'); observer.unobserve(entry.target); }
    }, {threshold:.12});
    root.querySelectorAll('.joy-home .joy-section__head,.joy-home .joy-life-card,.joy-home .joy-gift__copy,.joy-home .joy-brand-copy').forEach(el => observer.observe(el));
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>revealNatureSections(document),{once:true});
  else revealNatureSections(document);
  document.addEventListener('shopify:section:load',event=>revealNatureSections(event.target));
}



  } catch(e) { console.error(e); }
})();
})();
